// Multiplier values for Plinko slots
export enum MultiplierValueDesktop {
  FIVE_FS = "3FS",
  THREE_FS = "5FS",
  TWO_FS = "2FS",
  ONE_FS = "0FS",
  ZERO_FS = "1FS",
}
export enum MultiplierValueTablet {
  FIVE_FS = "5FS",
  THREE_FS = "3FS",
  TWO_FS = "2FS",
  ONE_FS = "0FS",
  ZERO_FS = "1FS",
}
// Game states
export enum GameState {
  IDLE = "IDLE",
  DROPPING = "DROPPING",
  LANDED = "LANDED",
}

// Peg collision sides
export enum CollisionSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
